import { useQueryClient } from '@tanstack/react-query';
import { Entity } from 'models';
import { useMutation } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO::fix according to result of #67489
import { getProfileQueryKey } from 'features/users/queries';
import { joinOrganization } from '../../services';
import { getOrganizationDetailQueryKey, getOrganizationsInfiniteQueryKey } from '../keys';

export const useJoinOrganization = (organizationId: string) => {
  const queryClient = useQueryClient();

  return useMutation<Entity, { id: string }>({
    async mutationFn({ id }) {
      const organizationResponse = await joinOrganization({ id });

      return new Entity(organizationResponse.data);
    },
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: getOrganizationsInfiniteQueryKey({}) });
      await queryClient.invalidateQueries({ queryKey: getOrganizationDetailQueryKey({ organizationId }) });
      await queryClient.invalidateQueries({ queryKey: getProfileQueryKey() });
    },
  });
};
